/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   ____  ____   ___  
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| |  _ \|  _ \ / _ \ 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || |  | |_) | |_) | | | |
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |  |  __/|  _ <| |_| |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___| |_|   |_| \_\\___/ 
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.horizon-ui.com/pro/
* Copyright 2022 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Flex, Grid, useColorModeValue } from '@chakra-ui/react';
// Custom components
import { VSeparator } from 'components/Separator/Separator';
import CompositeEditionIndexCard from 'views/admin/dashboards/default/components/CompositeEditionIndexCard';
import PendingWaitlistTable from 'views/admin/dashboards/default/components/PendingWaitlistTable';
import PendingDataSuggestionsCarousel from 'views/admin/dashboards/default/components/PendingDataSuggestionsCarousel';
import DashboardArtistGridCard from 'views/admin/dashboards/default/components/DashboardArtistGridCard';
import DashboardTradingFloorCard from 'views/admin/dashboards/default/components/DashboardTradingFloorCard';
import PendingGroupingsCarousel from 'views/admin/dashboards/default/components/PendingGroupingsCarousel';
import PendingScrapejobsCarousel from 'views/admin/dashboards/default/components/PendingScrapejobsCarousel';
import DashboardPendingListingsCard from 'views/admin/dashboards/default/components/DashboardPendingListingsCard';

export default function Default() {
  // Chakra Color Mode
  const paleGray = useColorModeValue('#DFE6F6', 'whiteAlpha.100');
  return (
    <Flex
      direction={{ base: 'column', xl: 'row' }}
      pt={{ base: '130px', md: '80px', xl: '80px' }}
    >
      <Flex direction="column" width="stretch">
        <Grid
          mb="20px"
          gridTemplateColumns={{ base: 'repeat(2, 1fr)', '2xl': '720fr 350fr' }}
          gap="20px"
          display={{ base: 'block', lg: 'grid' }}
        >
          <Flex gridArea={{ base: '1 / 1 / 2 / 3', '2xl': '1 / 1 / 2 / 2' }}>
            <CompositeEditionIndexCard />
          </Flex>
          <Flex gridArea={{ base: '2 / 1 / 3 / 3', '2xl': '1 / 2 / 2 / 3' }}>
            <PendingWaitlistTable />
          </Flex>
        </Grid>
        <Grid gap="20px" gridTemplateColumns={{ base: '1fr' }} mb="20px">
          <Flex>
            <DashboardTradingFloorCard />
          </Flex>
        </Grid>
        <Grid
          templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)', '2xl': '350fr 720fr' }}
          gap="20px"
          display={{ base: 'block', lg: 'grid' }}
        >
          {/* Left column: Data Suggestions - spans 2 rows */}
          <Flex gridArea={{ base: 'auto', lg: '1 / 1 / 3 / 2' }}>
            <PendingDataSuggestionsCarousel />
          </Flex>

          {/* Right column top: Groupings */}
          <Flex gridArea={{ base: 'auto', lg: '1 / 2 / 2 / 3' }}>
            <PendingGroupingsCarousel />
          </Flex>

          {/* Right column bottom: Scrapejobs */}
          <Flex gridArea={{ base: 'auto', lg: '2 / 2 / 3 / 3' }}>
            <PendingScrapejobsCarousel />
          </Flex>
        </Grid>
      </Flex>
      <VSeparator
        mx="20px"
        bg={paleGray}
        display={{ base: 'none', xl: 'flex' }}
      />
      <Flex
        direction="column"
        gap="20px"
        maxW={{ base: '100%', xl: '400px' }}
        w={{ base: '100%', xl: '400px' }}
      >
        <DashboardArtistGridCard />
        <DashboardPendingListingsCard />
      </Flex>
    </Flex>
  );
}
